export enum VimeoVideoId {
  WAIST_CIRCUMFERENCE_GUIDE = 1114395600,
  APPLE_HEALTH_SYNC_SETUP = 984273197
}
